// External libraries
import React, { useRef } from 'react';
import { useStoreState } from 'easy-peasy';
import { array, bool, func } from 'prop-types';
import {
  FloatingLabelSelect,
  LoadingElement,
} from '@checkout/react-components';

// Internal modules
import { $logger } from '@/lib/logger';
import { getContent } from '@/lib';
import { useOnMount } from '@/lib/reactHooks';

const NationalitySelectBox = props => {
  const nationality = useStoreState(({ form }) => form.nationality);
  const selectRef = useRef(null);
  useOnMount(() => {
    if (props.shouldFocusOnRender && selectRef?.current) {
      selectRef.current.focus();
    }
  });

  // If the territories list is not populated yet (from the initial
  // data GraphQL call), show the loading element
  if (!props.selectOptions?.length) {
    return <LoadingElement />;
  }

  return (
    <FloatingLabelSelect
      blurHandler={props.blurHandler}
      changeHandler={(e, newValue, oldValue, meta) => {
        $logger.fpti('weasley_process_nationality_change', {
          state_name: 'signup',
          transition_name: 'process_nationality_change',
        });
        props.changeHandler?.(e, newValue, oldValue, meta);
      }}
      focusHandler={props.focusHandler}
      id="nationality"
      label={getContent('fieldLabels.nationality')}
      name="nationality"
      required={true}
      selectOptions={props.selectOptions}
      selectRef={selectRef}
      {...nationality}
    />
  );
};

NationalitySelectBox.propTypes = {
  blurHandler: func.isRequired,
  changeHandler: func.isRequired,
  focusHandler: func,
  selectOptions: array.isRequired,
  shouldFocusOnRender: bool,
};

export { NationalitySelectBox };
